import { useEffect, useRef,useState,useMemo } from "react";
import "./BestSellingItem.css";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import ProductItem from "../../../common/ProductItem/ProductItem";
import { Link } from "react-router-dom";
import { useListAllQuery } from "../../../api/product.api";
import LoadingComponent from "../../../common/Loading/Loading.component";
import SectionHeading from "../../../common/SectionHeading/SectionHeading";
import "@splidejs/react-splide/css/core";
import { mediaPreloader } from "../../../utils/preloader";


const BestSellingItem = () => {
  const [assetsLoaded, setAssetsLoaded] = useState(false);
  const productRef = useRef(null);
  const { data, error, isLoading } = useListAllQuery({}, { 
    refetchOnMountOrArgChange: false,
    skip: false,
  });
   

  const product = useMemo(() => {
    return data?.result || [];
  }, [data]); 
  
  // Advanced preloading with batch processing
  useEffect(() => {
    if (product && !assetsLoaded) {
      const preloadAssets = async () => {
        try {
          const assets = [];
          product.forEach(item => {
            assets.push(
              { type: 'image', src: item.media?.[0]?.url || item.mainImage, priority: 'high' }
            );
          });

          // Batch preload all assets
          await mediaPreloader.batchPreload(assets);
          setAssetsLoaded(true);
        } catch (error) {
          console.warn('Asset preloading failed:', error);
          setAssetsLoaded(true); // Still show content even if preload fails
        }
      };

      preloadAssets();
    }
  }, [product, assetsLoaded]);

  const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };

  // Prepare shuffled products first
  const bestShuffleArray = shuffleArray([...product]);
  const limitedbestShuffleArray = bestShuffleArray.slice(0, 8);
  
 
  // Splide configuration for auto-width responsive behavior
  const splideOptions = {
    type: 'slide',
    drag: 'free', // Enable free dragging
    snap: false, // Disable snap for smooth free drag
    autoWidth: true, // IMPORTANT: Let slides take their natural width
    gap: '1rem',
    pagination: false,
    arrows: false,
    autoplay: false,
    keyboard: false,
    wheel: false, // Prevent vertical scroll conflicts
    waitForTransition: false,
    updateOnMove: true,
    start: 0, // Start from the first slide
    focus: 0, // Focus on the first slide (left alignment)
    trimSpace: false, // Don't trim empty space at the end
  };
  if (isLoading){
    return <LoadingComponent
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '50vh',
      backgroundColor: '#f9f9f9',
    }}
    />;
  }

  return (
    <div className="bestSelling div_container">
      <div className="container"  >
        <div className="best_heading_container">        
        <SectionHeading tag="h1" title="Best of MAYA." subtitle="Explore the most loved products from our latest collection. Each piece is crafted with care and designed to bring joy to your everyday life." />
        </div>
        <div className="best_container">
          <div className="best_flex" ref={productRef}>
            <Splide options={splideOptions} aria-label="Best Selling Products">
              {limitedbestShuffleArray.map((item) => (
                <SplideSlide key={item._id}>
                  <ProductItem
                    slug={item.slug}
                    _id={item._id}
                    images={item.media?.[0]?.url}
                    title={item.title}
                    price={item.price}
                    imageType={item.media?.[0]?.type}
                  />
                </SplideSlide>
              ))}
              <SplideSlide>
                <Link to="/all_product">
                  <div className="view_all_box">View all</div>
                </Link>
              </SplideSlide>
            </Splide>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BestSellingItem;
